import { CSS, StyleProps } from "@shared/primitive-components"

export const instructions = (props: StyleProps) => ({
  marginTop: props.theme.spacing(3),
  marginBottom: props.theme.spacing(4),
  alignItems: `center`,
})

export const link = (props: StyleProps): CSS => ({
  color: props.theme.palette.link,
  paddingLeft: props.theme.spacing(2),
})
